import { Box, Button, ModalProps, Text } from '@chakra-ui/react';

import Modal from '../../shared/Modal';

const NotEmployedWarning = ({ isOpen, onClose }: Pick<ModalProps, 'isOpen' | 'onClose'>) => {
  return (
    <Modal
      title="Cobuyer Required"
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}
      canDismiss={false}
      size="xl"
      rightButtons={<Button onClick={onClose}>OK</Button>}
    >
      <Box mx={8}>
        <Text fontWeight="bold">COBUYER REQUIRED:</Text>
        <Text fontWeight="normal">
          Banks require a co-buyer with income if the primary buyer is not employed. A cobuyer must
          be added before submitting this application.
        </Text>
      </Box>
    </Modal>
  );
};

export default NotEmployedWarning;
